export const extraAllowedTypes = ['.dwg', '.HEIC'];
